import React, { useState } from 'react';
import { Input } from './components/ui/Input';
import { Textarea } from './components/ui/Textarea';
import { Select } from './components/ui/Select';
import { Button } from './components/ui/Button';
import { CheckCircleIcon } from 'lucide-react';
interface FormData {
  assignee: string;
  title: string;
  description: string;
  priority: string;
}
interface FormErrors {
  assignee?: string;
  title?: string;
  description?: string;
  priority?: string;
}
const ASSIGNEES = [{
  value: 'john-smith',
  label: 'John Smith'
}, {
  value: 'sarah-johnson',
  label: 'Sarah Johnson'
}, {
  value: 'mike-chen',
  label: 'Mike Chen'
}, {
  value: 'emily-davis',
  label: 'Emily Davis'
}, {
  value: 'alex-rodriguez',
  label: 'Alex Rodriguez'
}];
const PRIORITIES = [{
  value: 'low',
  label: 'Low'
}, {
  value: 'medium',
  label: 'Medium'
}, {
  value: 'high',
  label: 'High'
}, {
  value: 'urgent',
  label: 'Urgent'
}];
export function App() {
  const [formData, setFormData] = useState<FormData>({
    assignee: '',
    title: '',
    description: '',
    priority: ''
  });
  const [errors, setErrors] = useState<FormErrors>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const validateForm = (): boolean => {
    const newErrors: FormErrors = {};
    if (!formData.assignee) {
      newErrors.assignee = 'Please select an assignee';
    }
    if (!formData.title.trim()) {
      newErrors.title = 'Case title is required';
    }
    if (!formData.description.trim()) {
      newErrors.description = 'Description is required';
    }
    if (!formData.priority) {
      newErrors.priority = 'Please select a priority level';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setIsSubmitting(true);
    // Mock API call
    await new Promise(resolve => setTimeout(resolve, 1500));
    setIsSubmitting(false);
    setShowSuccess(true);
    // Reset form after success
    setTimeout(() => {
      setFormData({
        assignee: '',
        title: '',
        description: '',
        priority: ''
      });
      setShowSuccess(false);
    }, 2000);
  };
  const updateField = (field: keyof FormData, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: undefined
      }));
    }
  };
  if (showSuccess) {
    return <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center p-8" data-id="element-0">
        <div className="max-w-md w-full" data-id="element-1">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-2">
            <div className="flex flex-col items-center justify-center py-4" data-id="element-3">
              <CheckCircleIcon className="w-16 h-16 text-green-500 mb-4" data-id="element-4" />
              <p className="text-lg font-medium text-gray-900 mb-1" data-id="element-5">
                Case assigned successfully!
              </p>
              <p className="text-sm text-gray-600" data-id="element-6">
                {ASSIGNEES.find(a => a.value === formData.assignee)?.label}{' '}
                has been notified.
              </p>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center p-8" data-id="element-7">
      <div className="max-w-md w-full" data-id="element-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-9">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-10">
            Assign Case
          </h1>
          <p className="text-gray-600 mb-6" data-id="element-11">
            Assign a general non-loan related case to a team member
          </p>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-12">
            <Select label="Assign To" options={ASSIGNEES} value={formData.assignee} onChange={value => updateField('assignee', value)} error={errors.assignee} required data-id="element-13" />

            <Input label="Case Title" type="text" placeholder="Brief description of the case" value={formData.title} onChange={e => updateField('title', e.target.value)} error={errors.title} required data-id="element-14" />

            <Textarea label="Description" placeholder="Provide detailed information about the case..." value={formData.description} onChange={e => updateField('description', e.target.value)} error={errors.description} rows={5} required data-id="element-15" />

            <Select label="Priority" options={PRIORITIES} value={formData.priority} onChange={value => updateField('priority', value)} error={errors.priority} required data-id="element-16" />

            <div className="pt-4" data-id="element-17">
              <Button type="submit" variant="primary" className="w-full" disabled={isSubmitting} data-id="element-18">
                {isSubmitting ? 'Assigning...' : 'Assign Case'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>;
}